/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MEDIA_TYPE, MODULE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { toast } from "react-toastify";
import { utility } from "../../framework/utility/utilityProvider";
import { Switch } from "@mui/material";

function ScheduleConstraintsEditForm(props) {

    const { SID } = useParams();
    const loc = useLocation();

    const [channel, setChannel] = useState([]);
    const navigate = useNavigate();
    const lang = useTranslation();
    const [enabledConstraints, _setEnableConstraints] = useState([]);
    const enabledConstraintsRef = useRef();
    const setEnabledConstraintsRef = (data) => {
        _setEnableConstraints(data);
        enabledConstraintsRef.current = data;
    }

    let blankDataItem = {
        SID: SID,
        Name: "",
        Channel: {},
        Type: MEDIA_TYPE[0],
        EnabledConstraints: [],
        Archive: false
    }

    const [dataItem, setDataItem] = useState(blankDataItem)

    useEffect(() => {
        pageRender();
    }, []);

    const pageRender = async () => {
        await loadcombo()
        if (SID > 0) {
            await loadEditData();
        }
    }

    const loadcombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
        let getConstraintsData = await API.getDataLookup(ENTITYNAME.Constraints);
        setEnabledConstraintsRef(getConstraintsData.data);
        setDataItem({ ...blankDataItem, EnabledConstraints: getConstraintsData.data })
    }

    const loadEditData = async () => {
        let res = await API.getEntity(ENTITYNAME.ScheduleConstraints, parseInt(SID));
        enabledConstraintsRef?.current?.filter((item0 => {
            res.data?.EnabledConstraints?.filter((item1 => {
                if (item0.SID == item1.SID) {
                    item0.isSelected = true;
                }
            }))
        }))
        if (res.success) {
            setDataItem({
                ...res.data,
                Name: res.data.SID ? loc.state?.copy ? 'Copy of ' + res.data.Name : res.data.Name : res.data.Name,
                EnabledConstraints: enabledConstraintsRef.current
            })
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const onChange = (e) => {
        if (e.target?.name === "Archive") {
            setDataItem(prev => ({ ...prev, Archive: !prev.Archive }));
        } else if (e.target?.name === "SelectAll") {
            const updatedConstraints = enabledConstraintsRef.current.map(item => {
                if (item.Type.ID === dataItem.Type.ID) {
                    return { ...item, isSelected: e.target.checked };
                }
                return { ...item, isSelected: false };
            });

            setEnabledConstraintsRef(updatedConstraints);

            setDataItem(prev => ({
                ...prev,
                SelectAll: e.target.checked,
                EnabledConstraints: updatedConstraints
            }));
        } else if (e.value && e.target && e.target.props && e.target.props.name === "Type") {
            const selectedType = e.value;

            const clearedConstraints = enabledConstraintsRef.current.map(item => ({ ...item, isSelected: false }));

            setEnabledConstraintsRef(clearedConstraints);

            setDataItem(prev => ({
                ...prev,
                Type: selectedType,
                SelectAll: false,
                EnabledConstraints: clearedConstraints
            }));
        } else {
            setDataItem(prev => ({ ...prev, [e.target.name]: e.target.value }));
        }
    };

    const onChangeEnabledConstraints = (e) => {
        const updated = enabledConstraintsRef.current.map(item => {
            if (item.Type.ID === dataItem.Type.ID && item.Name === e.target.name) {
                return { ...item, isSelected: e.target.checked };
            }
            return item;
        });

        const typeMatched = updated.filter(item => item.Type.ID === dataItem.Type.ID);
        const allSelected = typeMatched.every(item => item.isSelected);

        setEnabledConstraintsRef(updated);

        setDataItem(prev => ({
            ...prev,
            SelectAll: allSelected,
            EnabledConstraints: updated
        }));
    };

    const isValid = () => {
        if (dataItem.Name == undefined || dataItem.Name == "") {
            toast.error(`${lang.please_enter_name_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        if (Object.keys(dataItem.Channel).length == 0) {
            toast.error(`${lang.please_select_channel_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        if (Object.keys(dataItem.Type).length == 0) {
            toast.error(`${lang.please_select_type_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        return true
    }

    const onSave = async () => {
        if (isValid()) {
            const isCopy = loc.state?.copy;
            const isEdit = !isCopy && dataItem.SID > 0;

            const saveData = {
                SID: isCopy ? 0 : dataItem.SID,
                Name: dataItem.Name,
                Channel: { _id: dataItem.Channel._id, SID: dataItem.Channel.SID, FullChannelName: dataItem.Channel.FullChannelName},
                Type: { ID: dataItem.Type.ID, Type: dataItem.Type.Type},
                EnabledConstraints: dataItem.EnabledConstraints.filter( item => item.Type.ID === dataItem.Type.ID && item.isSelected),
                Archive: dataItem.Archive ?? false,
                SelectAll: dataItem.SelectAll ?? false,
                checkDuplicate: !isEdit, 
                query: [ ["Channel", "=", dataItem.Channel],["Type", "=", dataItem.Type] ]
            };
            if (isEdit) {
                saveData.query.push(["SID", "!=", dataItem.SID]);
            }
            let res = await API.saveData(ENTITYNAME.ScheduleConstraints, saveData);
            console.log(res);
            if (res.success) {
                let logData = {
                    event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT,
                    module: MODULE.SCHEDULE_CONSTRAINTS,
                    data: res.data,
                    message: res.message
                };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.ScheduleConstraints);
                onClose();
            } else {
                toast.error(`${res.message} ${dataItem.Channel.FullChannelName}, ${dataItem.Type.Type}`, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    };

    const borderWithTitle = {
        position: "relative",
        fontWeight: "500",
        fontSize: "18px",
        top: "-0.8em",
        marginLeft: "0.2em",
        display: "inline",
        backgroundColor: "#f7f5f5",
    };

    const onClose = () => {
        if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath)
        } else {
            navigate(-1);
        }
    }

    return (<>
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader title={dataItem.Name ? `${lang.schedule_constraints_error_message} -> ${dataItem.Name}` : `${lang.create_schedule_constraints_editpage_header}`} onSubmit={onSave} onCancel={onClose} />
                <div className="row mt-2">
                    <div className="col-4">
                        <label>{lang.name_label} *</label>
                        <input
                            className="form-control form-control-sm"
                            type="text"
                            name={"Name"}
                            onChange={onChange}
                            value={dataItem.Name}
                        />
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label htmlFor="TabView">{lang.channel_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={channel}
                                name="Channel"
                                textField="FullChannelName"
                                dataItemKey="_id"
                                value={dataItem.Channel}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label htmlFor="TabView">{lang.type_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={MEDIA_TYPE}
                                name="Type"
                                textField="Type"
                                dataItemKey="ID"
                                value={dataItem.Type}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 form-group">
                        <input type={"checkbox"} name={"Archive"}
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange} />
                        <label className='ml-1'>{lang.archive}</label>
                    </div>
                </div>
                <div className="row" style={{ margin: "8px 0px 15px 0px", border: '1px solid LightSeaGreen', borderRadius: '5px!important' }}>
                    <div className='col-12'>
                        <div style={borderWithTitle}>&nbsp; {lang.constraints_lable} &nbsp;</div>
                        <div className="row mt-2" style={{ marginLeft: "-34px" }}>
                            <div className="col-2 ml-2">
                                <Switch name={"SelectAll"} label={lang.select_all_label} checked={dataItem.SelectAll} value={dataItem.SelectAll} onChange={onChange} />
                                <label>{lang.select_all_label}</label>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-12">
                                <div className="row mt-3">
                                    <div className="col-4">
                                        <label style={{ fontSize: '20px', fontWeight: '500' }}>{lang.name_label}</label>
                                    </div>
                                    <div className="col">
                                        <label style={{ fontSize: '20px', fontWeight: '500' }}>{lang.description_label}</label>
                                    </div>
                                </div>
                                {enabledConstraints.map((item) => {
                                    return item.Type.ID == dataItem.Type.ID && <div className="row mt-2">

                                        <div className="col-4">
                                            <Switch
                                                name={item.Name}
                                                label={item.Name}
                                                onChange={onChangeEnabledConstraints}
                                                checked={item.isSelected}
                                                value={item.isSelected}
                                            />
                                        </div>
                                        <div className="col">
                                            {item.Description}
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ScheduleConstraintsEditForm;